import axios, { AxiosRequestConfig } from 'axios';

import { BASE_PATH } from '../common';
import { ApiRequestOptions, ApiResponse, Unit } from '../models';
import { apiOptionsToSearchParams, urlSearchParamsToUnencodedString } from '../requestUtils';

async function fetchUnits<Resolve = undefined, ResolveInSeparateList = undefined>(
  axiosOptions?: AxiosRequestConfig,
  apiOptions: ApiRequestOptions = { itemsPerPage: 5000 },
) {
  const searchParams = apiOptionsToSearchParams(apiOptions);
  searchParams.append('version', '2.0');

  const url = `${BASE_PATH}/unit?${urlSearchParamsToUnencodedString(searchParams)}`;

  return axios.get<ApiResponse<Unit[], Resolve, ResolveInSeparateList>>(url, axiosOptions);
}

export default fetchUnits;
